import parseISO from "date-fns/parseISO";
import format from "date-fns/format";


export const useFormattedDate = (dateIso) => {
    return format(parseISO(dateIso), 'HH:mm dd.LL.yy')
}